































































































































































import Vue from 'vue';
import * as _ from 'lodash';
import { Component, Prop, Watch } from "vue-property-decorator";
import TextInput from "./../../Card/Body/CardType/Form/FieldTypes/TextInput.vue";
import TextArea from "./../../Card/Body/CardType/Form/FieldTypes/TextArea.vue";

/*
    * Component's properties and events
*/
@Component({
      components: {
        TextInput,
        TextArea
    }
})

export default class HeaderComponent extends Vue  {
    
    /*
        *  A component’s data option must be a function, so that each instance can maintain an independent copy of the returned data object.
        *  this.$options.parent.fileName - current componets name
    */
    data() {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName || this.$options.parent.$parent.fileName], self = this;

        //#. Apply translation
        if (context.keyTranslator) {
            _.forOwn(context.tooltip.fields, function (key, val) {
                if (!key.orgTitle)
                    key.orgTitle = key.title;

                key.text = self.$t(key.orgTitle) || key.orgTitle;
                key.title = key.text;
            });
        }

        return context;
    }

    get _dgTitle() {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        return context.messages.tooltipEditor + ': ' + (this.$t(context.title) || context.title);
    }

    /*
        * While computed properties are more appropriate in most cases, there are times when a custom watcher is necessary.
        * That’s why Vue provides a more generic way to react to data changes through the watch option.
    */
   @Watch('tooltipDialogs')
   onPropertyChanged(value: string, oldValue: string) {
        value || this._tpClose()
   }
        /*
        * Define methods under the `methods` object
    */

    _inlSave(item) {
        let tooltipJson = {},
            records: string | null = null;

        //#. Update field name 
        // @ts-ignore
        item.OrgName = this.$store.state[this.$options.parent.fileName].fields.find(x => x.title == item.FieldName).value;
        tooltipJson[item.OrgName] = item.Description;

        //#. Check if the tooltip is empty...
        if (item.Description == "") {
            // @ts-ignore
            item.Description = this.$store.state[this.$options.parent.fileName].orgFields[item.OrgName].defaultTooltip;
            item.Description = (item.Description == undefined ? "" : item.Description);
            tooltipJson[item.OrgName] = item.Description;
        }

        records = JSON.stringify(tooltipJson);

        //#.Update action are triggered with the store.dispatch method.
        // @ts-ignore
        this.$store.dispatch('tooltip' + '/' + 'Update', { record: records, fieldName: item.OrgName, menuId: getParameterByName('mId'), Component: (this.$options.parent.moduleName).replace('Component', ''), fileName: this.$options.parent.fileName });
    }

    /*
        * Tooltip Data table - Shows tooltip list.
    */
    _inlEditForm(item, fieldName) {
        // @ts-ignore
        let context = this.$store.state.tooltip;
        // @ts-ignore          
        let records = this.$store.state[this.$options.parent.fileName].tooltipsFormData;
        let isEdit = false;

        //#.Check if the row is editable mode
        if (context.editedIndexArray && context.editedIndexArray.length > 0 && fieldName && context.editedIndexArray[0] == context.editedIndex) {
            context.rowIndex = records.indexOf(item);

            if (context.editedIndexArray[0] == context.rowIndex)
                return;
        }

        //#.Check if the componet is inline editor auto save enabled
        if (context.inlineEditor.enabled && context.inlineEditor.autoSave) {
            context.copyEditedIndex = null;
            context.editedIndexArray = [];
        }

        //#.Check if the componet is inline editor
        if (context.inlineEditor.enabled) {

            if (!context.inlineEditor.autoSave && context.editedIndexArray.length > 0) {
                //#.Enable notify are triggered with the store.dispatch method.
                // @ts-ignore
                this.$store.dispatch('enableNotify', { color: 'error', text: context.messages.rowFill });
                return;
            }

            //#.Check if the input is already modify
            if (context.inlineEditor.autoSave && context.isDirty) {
                let items = context.tooltipsFormData[context.editedIndex];
                context.copyEditedIndex = context.tooltipsFormData.indexOf(item);
                context.copyEditedItem = context.editedItem;

                if (items) {
                    isEdit = true;
                    this._inlSave(items);
                }
            }
        }

        //#.Disable the enabled save button
        context.buttonDisabled = false;

        //#.Reset the current operation
        context.formCreate = false;
        context.disabled = false;

        //#.Assigning editItem based on the index
        if (context.inlineEditor.autoSave && !isEdit)
            context.editedIndex = records.indexOf(item);
        else if (!context.inlineEditor.autoSave)
            context.editedIndex = records.indexOf(item);

        // @ts-ignore
        context.editedItem = Object.assign({}, item);

        //#.formCreated event raising methods
        // @ts-ignore
        this.$store.dispatch(context.fileName + '/formCreated', context);

        //#.Check form action be direct form submit or not
        if (!context.ajaxFormSubmit) {
            context.editedItem["FormData"] = new FormData();
        }

        //#.Check if the componet is inline editor
        if (context.inlineEditor.enabled) {
            //#.Store the updated records index
            context.editedIndexArray.push(context.editedIndex);
            return;
        }
    }

    /*
        * Inline editor - Will only reset changed input values and not alter their state
        * index - temporary record index
    */
    _inlCancel(item) {
        // @ts-ignore
        let context = this.$store.state.tooltip,
            index = context.tempData.indexOf(item);

        //#.Remove notify component in the DOM
        context.notify.enabled = false;

        //#.Add isDiry lisstener for controls in the form
        if (context.isDirty) {
            //#.Enable notify are triggered with the store.dispatch method.
            // @ts-ignore
            this.$store.dispatch('enableNotify', { color: 'confirm', text: context.messages.changesConfirm, record: item, name: this.$options.parent.fileName, type: 'tooltip' });
        } else {
            //#.Remove editable record index in the editedIndexArray
            if (context.editedIndexArray.length > 0) {
                // @ts-ignore
                delete context.editedIndexArray.splice(context.editedIndexArray.indexOf(this.$store.state[this.$options.parent.fileName].tooltipsFormData.indexOf(item)), 1);
            }

            //#.Removed newly added records in the temp data 
            if (index != -1) {
                // @ts-ignore
                delete this.$store.state[this.$options.parent.fileName].tooltipsFormData.splice(this.$store.state[this.$options.parent.fileName].tooltipsFormData.indexOf(context.notify.item), 1);
                // @ts-ignore
                delete context.tempData.splice(context.tempData.indexOf(context.notify.item), 1);
                return;
            }

            //#.When user click the close button reset the edit index
            context.editedIndex = null;
            context.isDirty = false;

            //#.Reset the current operation
            context.formCreate = false;
        }
    }

    /*
        * _tpClose - Dialog close when clicking dialog close button
    */
    _tpClose() {
        // @ts-ignore
        let context = this.$store.state[this.$options.parent.fileName];

        //#.Reset the edit index
        // @ts-ignore
        this.$store.state.tooltip.editedIndex = -1;

        //#.Remove dialog component in DOM
        // @ts-ignore
        context.tooltipsDialog = false;
    }   
}
